import { ColorRange } from '../../../../common/colorRange';
import { Component, OnInit, ElementRef, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { ManagedLinkKey } from 'src/common/managedLinkKey';
import { Observable, fromEvent, combineLatest } from 'rxjs';
import { AppState } from 'src/app/reducers';
import { Store } from '@ngrx/store';
import { AccesoAplicacion, AccesoAplicacionMarkable } from 'src/common/acceso';
import { debounceTime, distinctUntilChanged, map, startWith } from 'rxjs/operators';
import { aplicacionAll } from '../store/aplicacion/aplicacion.selectors';
import { AplicacionToggleMarkedRequested } from '../store/aplicacion/aplicacion.actions';

@Component({
	selector: 'app-aplicacion',
	templateUrl: './aplicacion.component.html',
	styleUrls: ['./aplicacion.component.scss']
})
export class AplicacionComponent implements OnInit, AfterViewInit, OnDestroy {

	readonly STORED_LINK: ManagedLinkKey = ManagedLinkKey.STORED_LINK;
	readonly ICON_SIZE: string = "3";
	readonly ICON_TEXT_SIZE: string = "1.5";
	readonly ALL_ACCESO: string = "ALL_ACCESO";

	filteredAccesos$: Observable<AccesoAplicacion[]>;
	colors: Object = {};	// key: nombre aplicación, value: color

	@ViewChild( "appFilter", { static: true } )
	appFilter: ElementRef;


	constructor( private store: Store<AppState>, private colorRange: ColorRange ) {
	}

	ngOnDestroy(): void {
	}

	ngAfterViewInit(): void {
		this.appFilter.nativeElement.focus();
	}

	ngOnInit() {
		let fromFilter$: Observable<string> = fromEvent<any>( this.appFilter.nativeElement, 'input' )
			.pipe(
				map( event => this.normalize( event.target.value ) ),
				debounceTime( 100 ),
				distinctUntilChanged(),
				startWith("")
			);

		let allAccesos$: Observable<AccesoAplicacionMarkable[]> = this.store.select( aplicacionAll )
			.pipe(
				map( accesos => {
					if( accesos && accesos.length > 0 ) {
						this.colors = this.colorRange.assignColors( accesos.map( app => app.nombre ) );
						accesos = accesos.map( app => {
							return { ...app, descNormalized: this.normalize( app.desc ) };
						});
					}
					return accesos;
				})
			);

		this.filteredAccesos$ = combineLatest( [ allAccesos$, fromFilter$ ] )
			.pipe(
				map( ([ accesos, filterText ]) =>
					filterText && filterText != ""? accesos.filter( acceso => acceso.descNormalized.indexOf( filterText ) >= 0 ): accesos
				)
			);
	}

	private normalize( text: string ): string {
		return text? text.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase(): text;
	}

	private onToggleMark( acceso: AccesoAplicacionMarkable ) {
		this.store.dispatch( new AplicacionToggleMarkedRequested( acceso ) );
	}

}
